import React from 'react';

const ProdutosIco = () => {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 31.4 32" space="preserve">
      <path class="st0" d="M31.4,28.6l-2.4-16c-0.2-1.5-1.5-2.6-3-2.6h-3.3V7c0-3.9-3.2-7-7-7c-3.9,0-7,3.1-7,7v3H5.4
	c-1.5,0-2.7,1.1-3,2.6L0,28.6C-0.2,30.4,1.2,32,3,32h25.4C30.2,32,31.6,30.4,31.4,28.6z M20.7,10h-10V7c0-2.8,2.2-5,5-5s5,2.2,5,5
	V10z"/>
    </svg>
  )
}

export default ProdutosIco;